import { isValidElement } from 'react';
const getElementName = (element) => {
    if (!isValidElement(element)) {
        return null;
    }
    return typeof element.type === 'string' ? element.type : element.type.name;
};
export default getElementName;
//# sourceMappingURL=getElementName.js.map